import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { UserActionTypes } from './types'
import { listSuccess, listError, updateSuccess, updateError, 
      createSuccess, createError, deleteSuccess, deleteError, resetPasswordSuccess, resetPasswordError, downloadSuccess, downloadError  } from './actions'
import { GeneralUtil } from '../../utils/generalUtil';
import { UserUtil } from '../../utils/userUtil';
import { Table } from '../interface'

const generalUtil: GeneralUtil = new GeneralUtil();
const userUtil: UserUtil = new UserUtil();

const getRecords = async (searchParams: any) => {
  searchParams.table = Table.User;
  return await generalUtil.GetList(searchParams);
}
const createRecord = async (doc: any) => {
  doc.table = Table.User; 
  return await generalUtil.Create(doc);
}
const updateRecord = async (keyValues: any) => {
  keyValues.table = Table.User; 
  return await generalUtil.Update(keyValues);
}
const deleteRecord = async (id:string) => {
  return await generalUtil.Delete(id, Table.User);
}
const resetPassword = async (keyValues: any) => {
  return await userUtil.ResetPassword(keyValues);
}
const downloadRecords = async (searchParams: any) => {
  searchParams.table = Table.User; 
  let downloadURL = await generalUtil.DownloadUserList(searchParams);
  return downloadURL;
}

function* handleList(action: any) {
  try {
    const res = yield call(getRecords, action.payload);
    if (res.isSuccess) {
      yield put(listSuccess(res))
    } else {
      yield put(listError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(listError(err.stack))
    } else {
      yield put(listError('An unknown error occured.'))
    }
  }
}

function* handleCreate(action: any) {
  try {
    const res = yield call(createRecord, action.payload);
    if (res.isSuccess) {
      yield put(createSuccess(res.doc))
    } else {
      yield put(createError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(createError(err.stack))
    } else {
      yield put(createError('An unknown error occured.'))
    }
  }
}

function* handleUpdate(action: any) {
  try {
    const res = yield call(updateRecord, action.payload);
    if (res.isSuccess) {
      yield put(updateSuccess(res.doc))
    } else {
      yield put(updateError({"errors": res.errors, "isConflict": res.isConflict}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(updateError(err.stack))
    } else {
      yield put(updateError('An unknown error occured.'))
    }
  }
}

function* handleDelete(action: any) {
  try {
    const res = yield call(deleteRecord, action.payload.id);
    if (res.isSuccess) {
      yield put(deleteSuccess(res.doc.id)); // Return delete
    } else {
      yield put(deleteError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(deleteError(err.stack))
    } else {
      yield put(deleteError('An unknown error occured.'))
    }
  }
}

function* handleResetPassword(action: any) {
  try {
    const res = yield call(resetPassword, action.payload);
    if (res.isSuccess) {
      yield put(resetPasswordSuccess(res.doc))
    } else {
      yield put(resetPasswordError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(resetPasswordError(err.stack))
    } else {
      yield put(resetPasswordError('An unknown error occured.'))
    }
  }
}

function* handleDownload(action: any) {
  try {
    const res = yield call(downloadRecords, action.payload);
    if (res != ""){
      yield put(downloadSuccess(res));
    } else{
      yield put(downloadError({"errors": "Download failed!"}))
    }
    // if (res.isSuccess) {
    //   yield put(downloadSuccess(res))
    // } else {
    //   yield put(downloadError({"errors": res.errors}))
    // }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(downloadError(err.stack))
    } else {
      yield put(downloadError('An unknown error occured.'))
    }
  }
}


function* watchListRequest() {
  yield takeEvery(UserActionTypes.LIST_REQUEST, handleList)
}

function* watchCreateRequest() {
  yield takeEvery(UserActionTypes.CREATE_REQUEST, handleCreate)
}

function* watchUpdateRequest() {
  yield takeEvery(UserActionTypes.UPDATE_REQUEST, handleUpdate)
}

function* watchDeleteRequest() {
  yield takeEvery(UserActionTypes.DELETE_REQUEST, handleDelete)
}

function* watchResetPasswordRequest() {
  yield takeEvery(UserActionTypes.RESETPASSWORD_REQUEST, handleResetPassword)
}

function* watcDownloadRequest() {
  yield takeEvery(UserActionTypes.DOWNLOAD_REQUEST, handleDownload)
}


function* UsersSaga() {
  yield all([
    fork(watchListRequest), 
    fork(watchUpdateRequest), 
    fork(watchCreateRequest), 
    fork(watchDeleteRequest),
    fork(watchResetPasswordRequest),
    fork(watcDownloadRequest)
  ]);
}

export default UsersSaga
